import React from 'react';
import { IconBaseProps } from 'react-icons';
import { MdPause } from 'react-icons/md';

const Hold: React.FC<IconBaseProps> = (props) => <MdPause {...props} />;

export default Hold;
